import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  undoStack: [],
  redoStack: [],
  present: {
    sceneObjects: [], // Replace with your object state (meshes, images, etc.)
  },
};

const undoRedoSlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    savePresent(state, action) {
      state.undoStack.push(JSON.parse(JSON.stringify(state.present)));
      state.present = action.payload;
      state.redoStack = [];
    },
    undo(state) {
      if (state.undoStack.length === 0) return;
      const previous = state.undoStack.pop();
      state.redoStack.push(JSON.parse(JSON.stringify(state.present)));
      state.present = previous;
    },
    redo(state) {
      if (state.redoStack.length === 0) return;
      const next = state.redoStack.pop();
      state.undoStack.push(JSON.parse(JSON.stringify(state.present)));
      state.present = next;
    },
    clearHistory(state) {
      state.undoStack = [];
      state.redoStack = [];
    },
  },
});

export const { savePresent, undo, redo, clearHistory } = undoRedoSlice.actions;
export default undoRedoSlice.reducer;
